<template>
<v-form ref="accessoriesForm" v-model="valid" lazy-validation>
    <h5>{{$t('myAccessoriesLabel')}}</h5>
    <v-row>
        <v-col md="6" sm="12">
            <v-text-field
                v-model="materialNo"
                :label="$t('materialNumberLabel')"
                dense
                hide-details
                :rules="[rules.isRequired(this.materialNo, $t('requiredValueLabel'))]"
                outlined></v-text-field>
        </v-col>
        <v-col md="6" sm="12">
            <v-text-field
                v-model="description"
                :label="$t('descriptionLabel')"
                dense
                hide-details
                :rules="[rules.isRequired(this.description, $t('requiredValueLabel'))]"
                outlined></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="6" sm="12">
            <v-text-field
                v-model="price"
                :label="$t('priceLabel')"
                dense
                hide-details
                :rules="[rules.isRequired(this.price, $t('requiredValueLabel')), rules.isFloat(this.price, '')]"
                outlined></v-text-field>
        </v-col>
        <v-col md="6" sm="12">
            <v-text-field
                v-model="quantity"
                :label="$t('quantityLabel')"
                dense
                hide-details
                :rules="[rules.isRequired(this.quantity, $t('requiredValueLabel')), rules.isNumber(this.quantity, '')]"
                outlined></v-text-field>
        </v-col>
    </v-row>
    <v-row class="my-4">
        <v-col cols="12">
            <v-btn depressed color="primary" @click="saveEventHandler">{{$t('addItem')}}</v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" class="py-0">
            <v-data-table
                :hide-default-footer="true"
                :hide-header="true"
                :headers="headers"
                :items="getAccessories"
                :loading="loading"
                :loading-text="$t('tableLoadingLabel')">
                <template v-slot:no-data>
                    {{$t('noDataAvailable')}}
                </template>
                <template v-slot:no-results>
                    {{$t('noDataAvailable')}}
                </template>
                <template #item.price="{item}">
                    {{item.price.toString().replace('.', ',')}}
                </template>
                <template #item.actions="{ item }">
                    <v-btn
                        class="mx-2"
                        fab
                        dark
                        x-small
                        color="red"
                        @click="deleteAccessories(item)"
                    >
                        <v-icon dark>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </template>
                <template v-slot:body.append>
                    <tr>
                        <th colspan="3"></th>
                        <th colspan="2">{{$t('totalPriceLabel')}}: {{getItemsSum.toString().replace('.', ',')}}</th>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</v-form>
</template>

<script>
import {parseToGermanFloat} from "@/services/ParserService";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "Accessories",
    data(){
        return{
            valid: true,
            materialNo: null,
            description: null,
            price: null,
            quantity: null,
            loading: false,
            headers: [
                {
                    text: this.$t('materialNumberLabel'),
                    value: 'materialNo'
                },
                {
                    text: this.$t('descriptionLabel'),
                    value: 'description'
                },
                {
                    text: this.$t('priceLabel'),
                    value: 'price'
                },
                {
                    text: this.$t('quantityLabel'),
                    value: 'quantity'
                },
                {
                    text: '',
                    sortable: false,
                    value: 'actions',
                    align: 'end'
                },
            ],
            rules:{
                isRequired(value, message){
                    return !!value || message
                },
                isNumber(value, message){
                    if(value !== null && !Number.isInteger(parseInt(value)))
                        return message;
                    return true
                },
                isFloat(value, message){
                    if(value !== null && value !== ''){
                        if (isNaN(parseFloat(value.replace(',','.'))))
                            return message;
                    }
                    return true
                }
            },
        }
    },
    computed:{
        ...mapGetters('furtherInformationModule',['getAccessories']),
        getItemsSum(){
            return this.getAccessories.reduce((a, b) => {
                return a + (parseFloat(b.price.replace(',', '.')) * b.quantity)
            }, 0).toFixed(2)
        }
    },
    methods:{
        ...mapActions('furtherInformationModule', ['deleteAccessories']),
        saveEventHandler(){
            const valid = this.$refs.accessoriesForm.validate()
            if(!valid)
                return

            const data = {
                id: '_' + Math.random().toString(36).substr(2, 9),
                materialNo: this.materialNo,
                description: this.description,
                price: parseFloat(this.price.replace(',','.')).toFixed(2),
                quantity: parseInt(this.quantity)
            }
            this.$store.dispatch('furtherInformationModule/setAccessories', data)

            this.materialNo = null
            this.description = null
            this.price = null
            this.quantity = null
            this.$refs.accessoriesForm.resetValidation()
        }
    }
}
</script>

<style scoped>

</style>